import React, { useState } from "react";
import { Page } from "../../components/page/page";
import { useSelector, useDispatch } from "react-redux";
import { setBirthPlace } from "../../store/stateSlice";
import { PlacesInput } from "../../../../components/places-input/places-input";

const YourBirthPlacePage = () => {
  const state = useSelector((store) => store.dateBirth);
  const dispatch = useDispatch();
  
  const [value, setValue] = useState(state.birthPlace ? state.birthPlace : null);
  
  const inputStyles = {borderBottomColor: '#51bddb'};

  return (
    <Page
      title="Where were you born?"
      nextPageLink="../your-birthtime"
      onContinue={() => dispatch(setBirthPlace(value))}
      canGoToNextPage={value !== null}
      currentStep={3}
    >
     <PlacesInput defaultValue={value} setValue={setValue} inputStyles={inputStyles} />
    </Page>
  );
};

export { YourBirthPlacePage };
